import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./UserPercentage.scss";

const HIGH_MATCH_THRESHOLD = 90;

const UserPercentage = ({ className, type, match }) => (
	<div
		className={classnames("match-percentage", {
			"match-percentage--high-match": match >= HIGH_MATCH_THRESHOLD,
			"match-percentage--oval": type === UserPercentage.Type.OVAL,
			"match-percentage--circle": type === UserPercentage.Type.CIRCLE,
		}, className)}
	>
		{match}%
	</div>
);

UserPercentage.Type = {
	OVAL: "OVAL",
	CIRCLE: "CIRCLE",
};

UserPercentage.propTypes = {
	className: PropTypes.string,
	match: PropTypes.number.isRequired,
	type: PropTypes.oneOf(Object.values(UserPercentage.Type)),
};

export default UserPercentage;



// WEBPACK FOOTER //
// ./src/shared/components/UserPercentage.jsx